import React, { Suspense, lazy, useContext, useEffect, useState } from "react";
import { LangContext } from "../../context/AppContext";
import { api_cares } from "../../api/cares";
import { CircularProgress } from "@mui/material";

// components
const BannerKPJ = lazy(() => import("./BannerKPJ"));
const MemberTierRanking = lazy(() => import("./MemberTierRanking"));
const CaresApplicationForm = lazy(() =>
  import("../../components/ApplicationForm/CaresApplicationForm")
);
const CaresBottom = lazy(() => import("./CaresBottom"));

function CaresKPJ() {
  // change website description
  const _title = `KPJ Cares`;
  document
    .querySelector('meta[name="description"]')
    .setAttribute("content", _title);
  // change page title
  document.title = _title;

  const { selectedLanguage } = useContext(LangContext);
  const [data, setData] = useState({
    AllData: {},
    CaresAppData: [],
    ScreeningPackagesData: [],
    PlatinumPlusData: [],
    MembershipTierRankingData: [],
    DetailData: [],
  });
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    api_cares(selectedLanguage)
      .then((response) => {
        if (response.status) {
          setLoading(true);
          const {
            cares_app,
            screening_packages,
            platinum_plus,
            membership_tier_ranking,
            detail,
          } = response.data;
          setData({
            CaresAppData: cares_app,
            ScreeningPackagesData: screening_packages,
            PlatinumPlusData: platinum_plus,
            MembershipTierRankingData: membership_tier_ranking,
            DetailData: detail,
            AllData: response.data,
          });
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [selectedLanguage]);

  useEffect(() => {
    return () => {
      // reset title and meta description
      // change website description
      document
        .querySelector('meta[name="description"]')
        .setAttribute("content", "KPJ");
      // change page title
      document.title = "KPJ";
    };
  }, []);

  if (isLoading) {
    return (
      <div className="loading-container">
        <CircularProgress />
      </div>
    );
  }

  return (
    <Suspense
      fallback={
        <div className="loading-container">
          <CircularProgress />
        </div>
      }
    >
      <BannerKPJ data={data?.DetailData} />
      <MemberTierRanking
        data={data?.MembershipTierRankingData}
        allData={data.AllData}
      />
      <CaresApplicationForm />
      <CaresBottom />
    </Suspense>
  );
}

export default CaresKPJ;
